import React, { useContext, useState, useEffect, useRef } from 'react';
import { func } from 'prop-types';
import { Link, LoadingButton } from '@one-thd/sui-atomic-components';
import { StorePodContext } from '../StorePod.context';
import { analytics } from '../analytics';
import { StorePodLoader } from './StorePodLoader';

export const StorePodLocalize = ({ onClick }) => {
  const localizerRef = useRef(null);
  const [isSelectingStore, setIsSelectingStore] = useState(false);
  const { isCanadianStore, isDesignStore, loading, store } = useContext(StorePodContext);

  const { storeId } = store;

  const setUserLocalStore = (id) => {
    const localizerRequest = {
      storeId: id,
      localizationMethod: 'change store overlay'
    };

    localizerRef.current.localize(localizerRequest)
      .then(() => {
        const urlParams = new URLSearchParams(window?.location?.search);
        if (urlParams.has('URL')) {
          let redirectURL = urlParams.get('URL');
          if (redirectURL !== '') {
            redirectURL = decodeURIComponent(redirectURL).replace(/amp;/g, '');
            window.location.assign(redirectURL);
          }
        } else if (!window.location.pathname.includes('/mycart') && !window.location.pathname.includes('/cart')) {
          window.location.reload();
        }
        onClick(id);
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.warn(`Error occurred on localize request - ${error}`));
  };

  const handleClick = (id) => {
    analytics.triggerAnalytics(id);
    setIsSelectingStore(true);
    setUserLocalStore(id);
  };

  useEffect(() => {
    import('Localizer')
      .then((Localizer) => { localizerRef.current = Localizer; })
      // eslint-disable-next-line no-console
      .catch((error) => console.warn(`Error occurred while loading Localizer - ${error}`));
  }, []);

  if (loading) {
    return (
      <div data-testid="store-pod-localize-loader" data-component="StorePodLocalizeLoader">
        <StorePodLoader height="4.4rem" />
      </div>
    );
  }

  // TODO use png/svg instead of css
  return (
    <div data-component="StorePodLocalize">
      {isCanadianStore && (
        <div className="sui-flex sui-items-center">
          <img
            alt="canadian flag"
            className="sui-mr-2"
            src="https://assets.homedepot-static.com/mcstore/images/canada_flag.png"
            height="50px"
            width="50px"
          />
          <span>
            To shop online at this store, please visit our Canadian site&nbsp;
            <Link
              href="//homedepot.ca"
              alt="home depot canadaian"
            >
              homedepot.ca
            </Link>
          </span>
        </div>
      )}
      {isDesignStore && (
        <div className="sui-flex sui-items-center">
          <span>Design your new kitchen & bath with more brands + dedicated, complimentary services.</span>
        </div>
      )}
      {!isDesignStore && !isCanadianStore && (
        <LoadingButton
          data-testid="store-pod-localize__button"
          variant="secondary"
          loading={isSelectingStore}
          fullWidth
          onClick={() => handleClick(storeId)}
        >
          <span>Shop This Store</span>
        </LoadingButton>
      )}
    </div>
  );
};

StorePodLocalize.displayName = 'StorePodLocalize';

StorePodLocalize.propTypes = {
  onClick: func
};

StorePodLocalize.defaultProps = {
  onClick: () => { }
};
